if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    }
  );
}

jQuery(document).ready(($) => {
  const AutoplayModal = {
    modal: null,
    trigger: null,
    close: null,
    dialog: null,
    video: null,
    load: () => {
      AutoplayModal.trigger = document.querySelector("#product__metavideo--open-modal");
      AutoplayModal.modal = document.querySelector("#autoplay-modal");
      AutoplayModal.close = $(AutoplayModal.modal).find(".icon-close")?.[0];
      AutoplayModal.dialog = $(AutoplayModal.modal).find(".ui-modal-dialog")?.[0];
      AutoplayModal.video = $(AutoplayModal.modal).find("video")?.[0];
    },
    teleportToBody: () =>  {
      const modal = AutoplayModal.modal;

      if (modal) {
        const originalParent = modal.parentNode;
        const placeholder = document.createComment('teleported-autoplay-modal');

        originalParent.replaceChild(placeholder, modal);
        document.body.appendChild(modal);

        return function restore() {
          placeholder.replaceWith(modal);
        }
      }
    },
    events: () => {
      const trigger = AutoplayModal.trigger;
      const targetModal = AutoplayModal.modal;
      const close = AutoplayModal.close;
      const dialog = AutoplayModal.dialog;

      if (!trigger || !targetModal) return;

      trigger.addEventListener("click", (e) => {
        AutoplayModal.methods.playVideo();
      });

      close.addEventListener("click", () => {
        AutoplayModal.methods.closeTargetModal();
      });

      dialog.addEventListener("click", (e) => {
        if (e.target !== dialog) return;
        e.stopPropagation();
        AutoplayModal.methods.closeTargetModal();
      });
    },
    methods: {
      playVideo: () => {
        const targetModal = AutoplayModal.modal;
        const video = AutoplayModal.video;
        if (video) {
          AutoplayModal.methods.closeAllPlayingVideo();
          $(targetModal)?.fadeIn(400, function () {
            video.currentTime = 0;
            video.play();
          });
          video.addEventListener("ended", function () {
            AutoplayModal.methods.closeTargetModal();
          });
        }
      },
      closeAllPlayingVideo: () => {
        document.querySelectorAll("video")?.forEach((video) => {
          if (!video.paused) {
            video.pause();
            video.currentTime = 0;
          }
          if (document.fullscreenElement || document.webkitFullscreenElement) {
            document.exitFullscreen?.() || document.webkitExitFullscreen?.();
          }
        });
      },
      closeTargetModal: () => {
        $(AutoplayModal.modal)?.fadeOut(function () {
          setTimeout(() => {
            $(this).css("display", "none");
          }, 600);
          AutoplayModal.methods.closeAllPlayingVideo();
        });
      }
    },
    init: () => {
      AutoplayModal.load();
      AutoplayModal.teleportToBody();
      AutoplayModal.events();
    },
  };

  AutoplayModal.init();
});
